export default __webpack_public_path__ + "static/14_19-28b6410279da932d680f9e40f4b1ed08.png";